// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jJI_yWlLMcfma6 {
  position: relative;
  width: 100%;
  max-width: 850px;
  margin: var(--ds-space-0, 0) auto;
  padding: var(--ds-space-400, 32px);
}
.jJI_yWlLMcfma6 h2 {
  font-size: 16px;
  line-height: 1;
}
.IjZtB5YDYMmlgC {
  position: relative;
  margin-bottom: var(--ds-space-300, 24px);
}
._XoDMnu5DHxUqm {
  position: relative;
  margin: var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-050, 4px) var(--ds-space-500, 40px);
  padding: var(--ds-space-100, 8px) var(--ds-space-0, 0);
}
.AwfDAU7gg3zp9n {
  position: absolute;
  top: 5px;
  left: -35px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"activityContainer": `jJI_yWlLMcfma6`,
	"windowModule": `IjZtB5YDYMmlgC`,
	"windowModuleTitle": `_XoDMnu5DHxUqm`,
	"windowModuleTitleIcon": `AwfDAU7gg3zp9n`
};
export default ___CSS_LOADER_EXPORT___;
